var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticStyle:{"text-align":"center","font-weight":"700","font-size":"24px"}},[_vm._v(" 金融助力激发“新动能” ")])])
}]

export { render, staticRenderFns }